import { Component, Input } from '@angular/core';
import { Events } from 'ionic-angular';
import { GlobalVariables } from '../../variables/global';
import { OnlineDemoModalPage } from '../../pages/online-demo-modal/online-demo-modal';
import { ModalController } from 'ionic-angular';
import { environment } from './../../environments/environment';


@Component({
  selector: 'dev-header',
  templateUrl: 'dev-header.html'
})
export class DevHeaderComponent {
  @Input() userLogged;
  public currentPage: string;
  homePagePath;
  documentationUrl: string = "https://flexiti.atlassian.net/wiki/spaces/FDP/overview?homepageId=130253026";
  userRole: string = 'ONLINE';

  ngAfterContentChecked() {
    this.currentPage = window.location.href;
  }

  constructor(
    public events: Events,
    public modalCtrl: ModalController) {
    this.homePagePath = '/#/home';
  }

  ngOnInit() {
    this.userRole = GlobalVariables.role;
  }
  ngOnChanges() {
    this.userRole = GlobalVariables.role;
  }
  signInButtonClass() {
    const buttonClass = (window.location.hash === '#/home') ? 'dev-header__account-menu-item' : 'dev-header__account-menu-item--hide';

    return buttonClass;
  }

  goBackButtonClass() {
    const buttonClass = (window.location.hash === '#/login') ? 'dev-header__account-menu-item' : 'dev-header__account-menu-item--hide';

    return buttonClass;
  }

  homeButtonClass() {
    const buttonClass = (window.location.hash === '#/home') ? 'dev-header__account-menu-item dev-header__bold-item' : 'dev-header__account-menu-item';

    return buttonClass;
  }

  handleUserAccountClick() {
    this.events.publish('nav:go', { link: GlobalVariables.pages.userAccount.link });
  }

  goToHomePage() {
    this.events.publish('nav:go', { link: GlobalVariables.pages.home.link });
  }

  goToLoginPage() {
    this.events.publish('nav:go', { link: GlobalVariables.pages.login.link });
  }

  logout() {
    this.events.publish('user:logout');
  }

  getAccountMenuItemClass() {
    return {
      "dev-header__account-menu-item": true,
      "dev-header__bold-item": this.currentPage.includes(GlobalVariables.pages.adminUsersDetail.link)
    }
  }
  openOnlineDemoModal() {
    let viewDemoModal = this.modalCtrl.create(OnlineDemoModalPage, {}, { cssClass: 'page-online-demo-modal__modal' });
    viewDemoModal.present();
  }

  openPosApiSwagger() {
    window.open('https://posapi-training.flexiti.fi/flexiti/pos-api/v2.5/docs/', "_system", "location=yes");
  }

  openTUSwagger() {
    window.open(environment.TU_URL + 'docs/#/', "_system", "location=yes");
  }
}



// WEBPACK FOOTER //
// ./src/components/dev-header/dev-header.ts